// extracted by mini-css-extract-plugin
module.exports = {"header":"file-field_header__2nO77","inputContainer":"file-field_inputContainer__2iwww","tooltip":"file-field_tooltip__3LCAw"};